import { render } from "./EditWorkStationDetailsPopup.vue?vue&type=template&id=c9fc9752&scoped=true&ts=true"
import script from "./EditWorkStationDetailsPopup.vue?vue&type=script&lang=ts"
export * from "./EditWorkStationDetailsPopup.vue?vue&type=script&lang=ts"

import "./EditWorkStationDetailsPopup.vue?vue&type=style&index=0&id=c9fc9752&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fc9752"]])

export default __exports__